import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { useAddOnsPage } from '../../../hooks/useAddOnPage';
import { useAppSelector } from '../../../reducers';
import { isUngatedForCommerceHubInbound25Selector } from '../../../selectors/GatingSelectors';
import HubPlanPickerRow from './HubPlanPickerRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HubPlanPickerListContainer = ({
  productLines
}) => {
  const {
    showAddonsPage
  } = useAddOnsPage();
  const isUngatedForCommerceHubInbound25 = useAppSelector(isUngatedForCommerceHubInbound25Selector);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    inlineSize: "100%",
    maxInlineSize: "700px",
    children: [/*#__PURE__*/_jsx(SectionTitle, {
      children: showAddonsPage ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.selectProducts"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.selectProductsAndAddons"
      })
    }), productLines.map(productLine => {
      if (productLine === 'COMMERCE' && !isUngatedForCommerceHubInbound25) {
        return null;
      }
      return /*#__PURE__*/_jsx(HubPlanPickerRow, {
        productLine: productLine
      }, productLine);
    })]
  });
};
export default HubPlanPickerListContainer;